import {RENEWAL_TYPE} from "./config";

/**
 * 性别过滤器
 * @param str
 * @param type
 * @returns {string}
 */
export function sexFilter(str, type = 1) {
  if (!str) return '';
  let data = {};
  str = str.toLowerCase();
  if (type === 1) {
    data = {f: '女', m: '男', n: '未知'};
  }
  return data[str] || '';
}

/**
 *
 * @param str
 * @returns {*}
 */
export function renewalTypeFilter(str) {
  const type = RENEWAL_TYPE.find(r => r.id === str);
  if (type && type.name) return type.name;
  return "";
}

/**
 * 由身份证获得sex
 * @param str
 * @returns {string}
 */
export const getSexFromIdCardFilter = function (str) {
  if (!str) return '';
  if (str.length === 18) {
    const sex = str.substring(16, 17);
    return sex % 2 === 1 ? '男' : '女';
  } else {
    return ''
  }
}

/**
 * 由身份证获得age
 * @param str
 * @returns {*}
 */
export const getAgeFromIdCardFilter = function (str, next = '岁') {
  if (!str) return '';
  const y = new Date().getFullYear();
  if (str.length === 18) {
    return (y - str.substring(6, 10)) + next;
  } else {
    return "";
  }
}

/**
 * 隐藏部分字符串
 * @param str
 * @param start
 * @param end
 * @param length
 * @returns {string}
 */
export const hiddenStr = function (str, start, end, length) {
  if (!str) return '';
  return str.substring(0, start) + new Array(length).fill('*').join('') + str.substring(str.length - end);
}
